import { render, staticRenderFns } from "./ReviewTask.vue?vue&type=template&id=1aa0d5f7&"
import script from "./ReviewTask.vue?vue&type=script&lang=js&"
export * from "./ReviewTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports